import type { Exercise } from "../lib/api";
import { useSheetDrag } from "../lib/useSheetDrag";
import ExerciseSearch from "./ExerciseSearch";

interface Props {
  title: string;
  hint: string;
  /** Что предложить до поиска: варианты из программы, если они есть. */
  suggestions?: Exercise[];
  suggestionsTitle?: string;
  /** Для замены: сверху «Похожие» — та же мышца и тип движения. */
  similarTo?: number;
  /**
   * Что убрать из выдачи. При замене — само упражнение; при добавлении — всё,
   * что уже есть в тренировке: подходы такого упражнения после перезагрузки
   * стали бы невидимы, потому что сервер не считает добавленным то, что уже
   * в плане.
   */
  exclude?: number[];
  onPick: (exercise: Exercise) => void;
  onClose: () => void;
}

/**
 * Выбор упражнения посреди тренировки — заменить занятое и добавить
 * незапланированное. Сам выбор — общий ExerciseSearch: до поиска похожие,
 * альтернативы и недавние, чтобы в зале не набирать текст.
 */
export default function ExercisePickSheet({
  title,
  hint,
  suggestions = [],
  suggestionsTitle = "Из программы",
  similarTo,
  exclude = [],
  onPick,
  onClose,
}: Props) {
  const body = useSheetDrag(onClose);
  return (
    <div className="sheet" role="dialog" aria-label={title}>
      <div className="sheet__backdrop" onClick={onClose} />
      <div className="sheet__body sheet__body--tall" ref={body}>
        <div className="sheet__grip" />
        <p className="sheet__title">{title}</p>
        <p className="lead" style={{ margin: 0 }}>
          {hint}
        </p>
        <ExerciseSearch
          sections={suggestions.length ? [{ title: suggestionsTitle, items: suggestions }] : []}
          similarTo={similarTo}
          exclude={exclude}
          excludedHint={
            exclude.length > 1
              ? "Найденное уже есть в этой тренировке — добавьте подходы к нему."
              : "Это то же самое упражнение."
          }
          onPick={onPick}
          // Своё упражнение прямо из зала: без этого ненайденное название — тупик.
          allowCreate
        />
      </div>
    </div>
  );
}
